import { axiosDS } from '@pp/axios'
import { urls } from 'Constants/Urls'
import { CreateFeedbackModel, FeedbackType } from 'Modules'

const sendFeedback = async (data: FeedbackType) => {
	const res = await axiosDS().post<CreateFeedbackModel>(urls.csat_feedback.index, { data })
	return res.data
}

export const feedbackApi = {
	sendFeedback,
}
